module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Delete-user-31a646e6cdafb4e4d26eda6d54d852e7.svg";